import type { Ssm5FreezeFramesDocumentFormat } from '@packages/domain/ssm5';

/**
 * Name the document of a DTC in its requested format.
 *
 * @param dtcCode - the trouble code of the document
 * @param format - the requested file format
 * @returns the file name under which to save
 */
export function freezeFramesDocumentName(dtcCode: string, format: Ssm5FreezeFramesDocumentFormat): string {
    return `FFD_Detail_${dtcCode}.${format}`;
}
